module.exports = __webpack_public_path__ + "img/image13.f8b04a67.webp";